var map = {
	"./format-bold.svg": 38755,
	"./format-header-1.svg": 4096,
	"./format-header-2.svg": 55433,
	"./format-header-3.svg": 55239,
	"./format-italic.svg": 34980,
	"./format-list-bulleted.svg": 60687,
	"./format-list-numbered.svg": 12176,
	"./format-quote-open.svg": 29241,
	"./format-strikethrough.svg": 64255,
	"./format-underline.svg": 14647,
	"./redo.svg": 18907,
	"./undo.svg": 96177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71610;